// Priority constants — single source of truth for priority labels, tones, and ranking
export const PRIORITIES = {
  'urgent': { label: 'Urgent', tone: 'rose',  rank: 4 },
  'high':   { label: 'High',   tone: 'amber', rank: 3 },
  'medium': { label: 'Medium', tone: 'blue', rank: 2 },
  'low':    { label: 'Low',    tone: 'slate', rank: 1 },
};

export const PRIORITY_DOT_COLOR = {
  rose: '#e11d48',
  amber: '#d97706',
  slate: '#6b7280',
  blue: '#2266ee'
};

export const PRIORITY_TONE_COLOR = {
  rose: 'var(--rose)',
  amber: 'var(--amber)',
  slate: 'var(--slate-text)',
  blue: 'var(--blue)',
};

export const PRIORITY_ICON = { urgent: 'flame', high: 'arrow-up', medium: 'activity', low: 'arrow-down' };
